import { api, SpeakingMonitoringResult } from 'api';
import { rtkQueryApi } from 'store/rtkQueryApi';

const speakingMonitoringDictionariesApi = rtkQueryApi.injectEndpoints({
  endpoints: (builder) => ({
    speakingMonitoringProcedureResults: builder.query<SpeakingMonitoringResult[], void>({
      query: () => {
        return api.speakingMonitoringResult.getProcedureResults();
      },
    }),
    speakingMonitoringRatingResults: builder.query<SpeakingMonitoringResult[], void>({
      query: () => {
        return api.speakingMonitoringResult.getRatingResults();
      },
    }),
    speakingMonitoringFinalResults: builder.query<SpeakingMonitoringResult[], void>({
      query: () => {
        return api.speakingMonitoringResult.getFinalRatingResults();
      },
    }),
  }),
});

export const {
  useSpeakingMonitoringProcedureResultsQuery,
  useSpeakingMonitoringRatingResultsQuery,
  useSpeakingMonitoringFinalResultsQuery,
} = speakingMonitoringDictionariesApi;
